/*
 *
 * Division actions
 *
 */

import {
  HAS_DIVISIONS_WATCHER,
  HAS_DIVISIONS_SUCCESS,
  HAS_DIVISIONS_FAILED,
  GET_TABLE_WATCHER,
  GET_TABLE_SUCCESS,
  GET_TABLE_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
  GET_TEMPLATE_DIVISION_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  GET_SUBDIVISIONS_TABLE_WATCHER,
  GET_SUBDIVISIONS_TABLE_SUCCESS,
  GET_SUBDIVISIONS_TABLE_FAILED,
  GET_DIVISIONS_UNASSIGNED_WATCHER,
  GET_DIVISIONS_UNASSIGNED_SUCCESS,
  GET_DIVISIONS_UNASSIGNED_FAILED,
  ADD_SUBDIVISION_TABLE_WATCHER,
  ADD_SUBDIVISION_TABLE_FAILED,
  ADD_SUBDIVISION_TABLE_SUCCESS,
  DELETE_SUBDIVISION_TABLE_WATCHER,
  DELETE_SUBDIVISION_TABLE_SUCCESS,
  DELETE_SUBDIVISION_TABLE_FAILED,
  GET_DIVISION_PARENTS_WATCHER,
  GET_DIVISION_PARENTS_SUCCESS,
  GET_DIVISION_PARENTS_FAILED,
  SELECT_DIVISION_SUPERIOR_WATCHER,
  SELECT_DIVISION_SUPERIOR_SUCCESS,
  SELECT_DIVISION_SUPERIOR_FAILED,
  DELETE_DIVISION_TABLE_WATCHER,
  DELETE_DIVISION_TABLE_SUCCESS,
  DELETE_DIVISION_TABLE_FAILED,
  LEAVE_TABLE,
  GET_COLLABORATORS_TABLE_WATCHER,
  GET_COLLABORATORS_TABLE_SUCCESS,
  DELETE_DIVISIONS_WATCHER,
  DELETE_DIVISIONS_FAILED,
  DELETE_DIVISIONS_SUCCESS,
  TOGGLE_TABLE_VIEW,
  CHANGE_EXPANDED_ROWS,
  RESET_EXPANDED_ROWS,
  CREATE_DIVISION_WATCHER,
  CREATE_DIVISION_SUCCESS,
  CREATE_DIVISION_FAILED,
} from "./constants"

export function resetExpandedRows() {
  return { type: RESET_EXPANDED_ROWS }
}

export function changeExpandedRows(payload) {
  return {
    type: CHANGE_EXPANDED_ROWS,
    payload,
  }
}

export function toggleTableView(payload) {
  return {
    type: TOGGLE_TABLE_VIEW,
    payload,
  }
}

export function setLeave(payload) {
  return {
    type: LEAVE_TABLE,
    payload,
  }
}

// HAS DIVISIONS
export function hasDivisionsWatcher() {
  return { type: HAS_DIVISIONS_WATCHER }
}

export function hasDivisionsSucces(payload) {
  return {
    type: HAS_DIVISIONS_SUCCESS,
    payload,
  }
}

export function hasDivisionsFailed(payload) {
  return {
    type: HAS_DIVISIONS_FAILED,
    payload,
  }
}

// GET DIVISION
export function getDivisionsWatcher(payload) {
  return {
    type: GET_TABLE_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_TABLE_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed(payload) {
  return {
    type: GET_TABLE_FAILED,
    payload,
  }
}

// UPLOAD TEMPLATE
export function uploadTemplate(payload) {
  return {
    type: UPLOAD_TEMPLATE_WATCHER,
    payload,
  }
}

export function uploadTemplateSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_SUCCESS,
    payload,
  }
}

export function uploadTemplateFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_FAILED,
    payload,
  }
}

// GET TEMPLATE
export function getTemplateDivision(payload) {
  return {
    type: GET_TEMPLATE_DIVISION_WATCHER,
    payload,
  }
}

export function getTemplateSuccess(payload) {
  return {
    type: GET_TEMPLATE_SUCCESS,
    payload,
  }
}

export function getTemplateFailed(payload) {
  return { type: GET_TEMPLATE_FAILED }
}

// GET SUBDIVISIONS TABLE
export function getSubdivisionsTableWatcher(payload) {
  return {
    type: GET_SUBDIVISIONS_TABLE_WATCHER,
    payload,
  }
}

export function getSubdivisionsTableSuccess(payload) {
  return {
    type: GET_SUBDIVISIONS_TABLE_SUCCESS,
    payload,
  }
}

export function getSubdivisionsTableFailed(payload) {
  return { type: GET_SUBDIVISIONS_TABLE_FAILED }
}

// GET DIVISIONS UNASSIGNED
export function getDivisionsUnassignedWatcher(payload) {
  return {
    type: GET_DIVISIONS_UNASSIGNED_WATCHER,
    payload,
  }
}

export function getDivisionsUnassignedSuccess(payload) {
  return {
    type: GET_DIVISIONS_UNASSIGNED_SUCCESS,
    payload,
  }
}

export function getDivisionsUnassignedFailed(payload) {
  return { type: GET_DIVISIONS_UNASSIGNED_FAILED }
}

// ADD SUBDIVISION
export function addSubdivisionTableWatcher(payload) {
  return {
    type: ADD_SUBDIVISION_TABLE_WATCHER,
    payload,
  }
}

export function addSubdivisionTableSuccess(payload) {
  return {
    type: ADD_SUBDIVISION_TABLE_SUCCESS,
    payload,
  }
}

export function addSubdivisionTableFailed(payload) {
  return { type: ADD_SUBDIVISION_TABLE_FAILED }
}

// DELETE SUBDIVISION TABLE
export function deleteSubdivisionTableWatcher(payload) {
  return {
    type: DELETE_SUBDIVISION_TABLE_WATCHER,
    payload,
  }
}

export function deleteSubdivisionTableSuccess(payload) {
  return {
    type: DELETE_SUBDIVISION_TABLE_SUCCESS,
    payload,
  }
}

export function deleteSubdivisionTableFailed(payload) {
  return {
    type: DELETE_SUBDIVISION_TABLE_FAILED,
    payload,
  }
}

// GET DIVISION PARENTS
export function getDivisionParentsWatcher(payload) {
  return {
    type: GET_DIVISION_PARENTS_WATCHER,
    payload,
  }
}

export function getDivisionParentsSuccess(payload) {
  return {
    type: GET_DIVISION_PARENTS_SUCCESS,
    payload,
  }
}

export function getDivisionParentsFailed(payload) {
  return { type: GET_DIVISION_PARENTS_FAILED }
}

// SELECT DIVISION SUPERIOR
export function selectDivisionSuperiorWatcher(payload) {
  return {
    type: SELECT_DIVISION_SUPERIOR_WATCHER,
    payload,
  }
}

export function selectDivisionSuperiorSuccess(payload) {
  return {
    type: SELECT_DIVISION_SUPERIOR_SUCCESS,
    payload,
  }
}

export function selectDivisionSuperiorFailed(payload) {
  return { type: SELECT_DIVISION_SUPERIOR_FAILED }
}

// DELETE DIVISION
export function deleteDivisionTableWatcher(payload) {
  return {
    type: DELETE_DIVISION_TABLE_WATCHER,
    payload,
  }
}

export function deleteDivisionTableSuccess(payload) {
  return {
    type: DELETE_DIVISION_TABLE_SUCCESS,
    payload,
  }
}

export function deleteDivisionTableFailed(payload) {
  return { type: DELETE_DIVISION_TABLE_FAILED }
}

// GET COLLABORATORS
export function getCollaboratorsTableWatcher(payload) {
  return {
    type: GET_COLLABORATORS_TABLE_WATCHER,
    payload,
  }
}

export function getCollaboratorsTableSuccess(payload) {
  return {
    type: GET_COLLABORATORS_TABLE_SUCCESS,
    payload,
  }
}

export function getCollaboratorsTableFailed(payload) {
  return { type: GET_COLLABORATORS_TABLE_FAILED }
}

// DELETE DIVISIONS
export function deleteDivisionsWatcher(payload) {
  return {
    type: DELETE_DIVISIONS_WATCHER,
    payload,
  }
}

export function deleteDivisionsSuccess(payload) {
  return {
    type: DELETE_DIVISIONS_SUCCESS,
    payload,
  }
}

export function deleteDivisionsFailed(payload) {
  return {
    type: DELETE_DIVISIONS_FAILED,
    payload,
  }
}


export const createDivisionWatcher = (payload) => {
  return {
    type: CREATE_DIVISION_WATCHER,
    payload,
  }
}

export const createDivisionSuccess = (payload) => {
  return {
    type: CREATE_DIVISION_SUCCESS,
    payload,
  }
}

export const createDivisionFailed = (payload) => {
  return {
    type: CREATE_DIVISION_FAILED,
    payload,
  }
}
